module.exports = __webpack_public_path__ + "img/Grundriss 1.OG.fa1ef6ba.jpg";